<template>
  <div
    id="how-it-works"
    class="w-full text-primary md:py-10 md:px-6 md:bg-gray-100 md:mb-0 xl:px-20"
  >
    <div class="container">
      <button
        class="toggle-button w-full flex items-center justify-between px-4 py-3 text-sm font-bold border-t border-b border-gray-300 md:hidden md:px-6 lg:px-8"
        @click="(e) => { isOpen = !isOpen; e.currentTarget.blur() }"
      >
        {{ tr('pages.sales.buy.howItWorks.title') }}

        <div class="flex-shrink-0 ml-4">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 152.51 247.97" v-bind:svg-inline="''" :class="['h-4 w-4 transform', isOpen ? '-rotate-90' : 'rotate-180']" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M124 248l28.35-28.36L56.25 124l96.26-95.57L124 0 0 124l124 124" fill="#05164d"/></svg>
        </div>
      </button>

      <div class="hidden md:block">
        <p class="md:text-lg xl:text-2.5xl font-lufthansa-head">
          {{ tr('pages.sales.buy.howItWorks.title') }}
        </p>
      </div>

      <div :class="['w-full flex-col bg-gray-100 py-6 px-4 md:px-0 md:pt-2 md:pb-0 md:flex-row md:flex', isOpen ? '' : 'hidden']">
        <div class="flex items-center mb-12 md:flex-col md:w-1/3 md:px-6 md:mb-0">
          <div class="flex-shrink-0 w-15 md:w-auto md:h-20 md:flex md:items-center">
            <div class="w-11 md:w-15">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 247.5 205" v-bind:svg-inline="''" v-bind:class="'w-full h-10 xl:h-12.5'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#05164d" d="M210 96.9a47.18 47.18 0 01-15 0v85.6H45v-100h120.83a52.46 52.46 0 01-10.69-15H37.94A8 8 0 0030 75.44V190H0v5a10 10 0 0010 10h220a10 10 0 0010-10v-5h-30zm-65 95.6a5 5 0 01-5 5h-40a5 5 0 01-5-5V190h50z"/><path fill="#05164d" d="M202.5 90a45 45 0 10-45-45 45 45 0 0045 45zm-16.67-51.35l11.79 10.78 23-26.21L231 32.36l-32.3 36.81-22.22-20.32zm-94.05 66.92a3.84 3.84 0 00-3.84-3.85h-5.13a3.85 3.85 0 00-3.81 3.85v5.13a3.84 3.84 0 003.85 3.84h5.13a3.84 3.84 0 003.84-3.84zm0 24.36a3.84 3.84 0 00-3.84-3.84h-5.13a3.84 3.84 0 00-3.81 3.84v5.14a3.84 3.84 0 003.85 3.84h5.13a3.84 3.84 0 003.84-3.84zm-3.84 20.53h-5.13A3.84 3.84 0 0079 154.3v5.13a3.85 3.85 0 003.85 3.85h5.13a3.84 3.84 0 003.84-3.85v-5.13a3.84 3.84 0 00-3.88-3.84zm66.69-48.74h-48.74a6.41 6.41 0 100 12.82h48.74a6.41 6.41 0 000-12.82zm0 24.37h-48.74a6.41 6.41 0 100 12.82h48.74a6.41 6.41 0 000-12.82zm0 24.37h-48.74a6.41 6.41 0 100 12.82h48.74a6.41 6.41 0 000-12.82z"/></svg>
            </div>
          </div>
          <div class="md:w-full md:text-center">
            <p class="text-lg leading-tight md:text-sm xl:text-lg">
              {{ tr('pages.sales.buy.howItWorks.step1') }}
            </p>
          </div>
        </div>

        <div class="flex items-center mb-12 md:flex-col md:w-1/3 md:px-6 md:mb-0">
          <div class="flex-shrink-0 w-15 md:w-auto md:h-20 md:flex md:items-center">
            <div class="w-7.5 md:w-10">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 151.61 183.86" v-bind:svg-inline="''" v-bind:class="'w-full h-10 md:h-12.5'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#05164d"><path d="M56.11 71.11c3.25-6 9.75-9.5 17-9.5 7.5 0 14.25 4.25 18 11.25l12 22.75a9.37 9.37 0 002.75.25c6.5 0 9.75-4.75 11-8.5l7.25-39.25L7.36 27.61.11 69.11a8.23 8.23 0 006.75 9.5l48.5 8.5a17.94 17.94 0 01.75-16zM127.61 27.11a8.23 8.23 0 00-6.75-9.5L20.36.11a8.23 8.23 0 00-9.5 6.75l-1.5 9 116.75 20.5z"/><path d="M148.61 76.61l-18.75-18.25-5 28.5c-1.25 7-7.25 16.5-19 16.5a25.71 25.71 0 01-4.25-.25l-3.75-.5-4.25-8.75-9.25-17.5c-2.75-5.25-7-7.5-11.5-7.5-8 0-15.5 7.75-9.25 18l1 1.75 4.25 8 13.5 25c.25 1 .25 1.5.5 2.25.5 5 2.5 15.5 6.75 21.75 4 6.75 10.5 11 11.5 12v26.25h50.5v-100a9 9 0 00-3-7.25z"/></g></svg>
            </div>
          </div>
          <div class="md:w-full md:text-center">
            <p class="text-lg leading-tight md:text-sm xl:text-lg">
              {{ tr('pages.sales.buy.howItWorks.step2') }}
            </p>
          </div>
        </div>

        <div class="flex items-center md:flex-col md:w-1/3 md:px-6">
          <div class="flex-shrink-0 w-15 md:w-auto md:h-20 md:flex md:items-center">
            <div class="w-11 md:w-15">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63.5 43.44" style="zoom:1" v-bind:svg-inline="''" v-bind:class="'w-full h-10 md:h-12.5'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#05164d" d="M17.12 27.01h3.11l-9.85 16.43h3.11l17.64-16.43h9.37c3.44-.06 6.19-1.18 6.19-2.56s-2.75-2.5-6.19-2.57h-9.37L13.49 5.4h-3.11l9.85 16.45h-3.11a98.4 98.4 0 00-9.86 1.54l-4.67-5.14H0l3.63 6.17L0 30.59h2.59l4.67-5.14c1.74.33 7.82 1.48 9.86 1.56zM-19568.742-2161.914h4.79v-1.65h-4.79m9.73 3.39c2.55 0 4.06-1.23 4.06-3.54a3.16 3.16 0 00-2.84-3.46 3.21 3.21 0 00-.62 0 2.66 2.66 0 00-1.91.62l.14-1.7h4.46v-.28h-6.51l-.362 5.79h2.15a1.44 1.44 0 011.49-.81c1.2 0 1.75.56 1.75 1.53s-.5 1.57-1.8 1.57c-1 0-1.5-.44-1.62-1.15h-2.278c.109 1.67 1.298 3.08 3.888 3.08m9.131-10.22c-2.78 0-4.18 1.76-4.18 5.11s1.4 5.11 4.18 5.11 4.19-1.76 4.19-5.11-1.4-5.11-4.19-5.11m0 2c1.27 0 1.9.94 1.9 3.14s-.63 3.14-1.9 3.14-1.9-.94-1.9-3.14.63-3.14 1.9-3.14m10.52 6.25a2 2 0 01-1.88-1.33h2.68v-1.38h-3a3 3 0 010-.43v-.36h3v-1.38h-2.7a2 2 0 011.9-1.37c1.17 0 1.91.38 2.14 1.42h2.28c-.27-2.12-1.65-3.42-4.42-3.42a4 4 0 00-4.27 3.37h-1.17v1.38h1v.36a3.1 3.1 0 000 .43h-1v1.38h1.18a4 4 0 004.26 3.3c2.77 0 4.15-1.3 4.42-3.39h-2.28c-.22 1.04-.97 1.42-2.14 1.42"/></svg>
            </div>
          </div>
          <div class="md:w-full md:text-center">
            <p class="text-lg leading-tight md:text-sm xl:text-lg">
              {{ tr('pages.sales.buy.howItWorks.step3') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HowItWorks from '~brand-components/base/sale/how-it-works'

export default HowItWorks.extend()
</script>

<style lang="scss" scoped>
.toggle-button {
  position: relative;

  &:focus {
    outline: none;

    &::before {
      content: '';
      position: absolute;
      left: -6px;
      top: -6px;
      width: calc(100% + 12px);
      height: calc(100% + 12px);
      box-shadow: 0 0 0.6rem 0.1rem #52627c;

      @apply rounded;

    }
  }
}
</style>
</style>
